/******/ (() => { // webpackBootstrap
/*!*********************************!*\
  !*** ./src/js/splide-config.js ***!
  \*********************************/
SplideConfig = {
  initSplides: function initSplides() {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.splide:not(.splide-custom):not(.custom-splider):not(.splide-delayed-init)';
    var splides = document.querySelectorAll(selector);
    if (splides.length) {
      splides.forEach(this.initializeSlider);
    }
  },
  initDelayedSplides: function initDelayedSplides() {
    var _this = this;
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.splide.splide-delayed-init';
    var splides = document.querySelectorAll(selector);
    if (splides.length) {
      var observer = new IntersectionObserver(function (entries, observerInstance) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var splide = entry.target;
            _this.initializeSlider(splide);

            // Stop observing after initialization
            observerInstance.unobserve(splide);
          }
        });
      }, {
        root: null,
        threshold: 0.1
      });
      splides.forEach(function (splide) {
        return observer.observe(splide);
      });
    }
  },
  initializeSlider: function initializeSlider(splide) {
    var splidePageClass = 'splide__pagination__page !bg-transparent !h-auto !w-auto !py-2 after:!h-[2px] after:!w-[40px] !m-0 !mx-[6px] !rounded-none after:!bg-blue-1 after:block !opacity-50 [&.is-active]:!opacity-100';
    if (splide.classList.contains('splide--dotted-pag')) {
      splidePageClass = 'splide__pagination__page [&.is-active]:!scale-110 [&.is-active]:!bg-blue-1';
    }
    var splideInstance = new Splide(splide, {
      classes: {
        pagination: 'splide__pagination text-[0px] !static !mt-10 flex-wrap gap-y-2',
        page: splidePageClass,
        arrow: 'splide__arrow'
      }
    });
    splideInstance.on('move', function () {
      var videos = splide.querySelectorAll('video');
      if (videos) {
        videos.forEach(function (video) {
          video.pause();
        });
      }
      if (document.querySelector('#colour-picker-mobile')) {
        document.querySelector('#colour-picker-mobile').classList.remove('!-translate-y-full', '!opacity-100', '!visible');
      }
    });
    splideInstance.on('active', function (slide) {
      var video = slide.slide.querySelector('video');
      if (video) {
        video.play();
      }
    });

    // Custom pagination
    var pagination = splide.querySelectorAll('.splide-pag > *');
    if (pagination.length) {
      pagination.forEach(function (pagItem, index) {
        pagItem.addEventListener('click', function (e) {
          e.preventDefault();
          splideInstance.go(index);
        });
      });
      splideInstance.on('moved', function (i) {
        pagination.forEach(function (pagItem) {
          pagItem.classList.remove('active', 'font-semibold', 'underline');
        });
        pagination[i].classList.add('active', 'font-semibold', 'underline');
      });
    }

    // Counter & progress bar
    var bar = splide.querySelector('.slider-progress-bar');
    var slideCounterPage = splide.querySelector('[data-splide-current-page]');
    var slideCounterTotal = splide.querySelector('[data-splide-total-pages]');
    if (slideCounterPage !== null) {
      var updateCounterAndProgressBar = function updateCounterAndProgressBar() {
        var index = splideInstance.index,
          length = splideInstance.length;
        var perPage = splideInstance.options.perPage;
        var totalPages = Math.ceil(length / perPage);
        var currentPage = Math.ceil((index + perPage) / perPage);
        if (totalPages < 2) {
          var _splide$querySelector, _splide$querySelector2;
          (_splide$querySelector = splide.querySelector('[data-splide-nav]')) === null || _splide$querySelector === void 0 || _splide$querySelector.remove();
          (_splide$querySelector2 = splide.querySelector('[data-splide-progress-bar]')) === null || _splide$querySelector2 === void 0 || _splide$querySelector2.remove();
          return;
        }
        slideCounterPage.textContent = String(currentPage);
        slideCounterTotal.textContent = String(totalPages);
        if (bar) {
          var rate = currentPage / totalPages;
          bar.style.width = "".concat(rate * 100, "%");
        }
      };
      splideInstance.on('ready move', updateCounterAndProgressBar);
    }
    splideInstance.mount();
    window.addEventListener('spliderefresh', function () {
      splideInstance.refresh();
    });
  },
  initializeProductGallery: function initializeProductGallery() {
    document.querySelectorAll('.splide-gallery-mob').forEach(function (gallery) {
      var parentProductWrapper = gallery.closest('.product');
      var main = new Splide(gallery, {
        pagination: true,
        arrows: true,
        cover: true
      });
      var thumbnailSliderElement = document.querySelector('.splide-thumbnail-gallery');
      if (!thumbnailSliderElement) {
        return;
      }
      var thumbnailSlider = new Splide(thumbnailSliderElement, {
        direction: 'ttb',
        height: '100%',
        perPage: 7,
        perMove: 1,
        gap: '8px',
        pagination: false,
        arrows: true,
        isNavigation: true
      });
      main.sync(thumbnailSlider);
      main.mount();
      thumbnailSlider.mount();
      main.on('move drag', function () {
        var colourPicker = parentProductWrapper === null || parentProductWrapper === void 0 ? void 0 : parentProductWrapper.querySelector('#colour-picker-mobile');
        if (colourPicker) {
          colourPicker.classList.remove('!-translate-y-full', '!opacity-100', '!visible');
        }
      });
      window.addEventListener('splidegalrefresh', function () {
        window.dispatchEvent(new Event('lazyimg'));
        main.refresh();
        thumbnailSlider.refresh();
      });
      requestAnimationFrame(function () {
        requestIdleCallback(function () {
          main.refresh();
          thumbnailSlider.refresh();
        });
      });
      window.addEventListener('resize', function () {
        main.refresh();
      });
    });
  }
};

// Initialize all regular and delayed sliders
document.addEventListener('DOMContentLoaded', function () {
  SplideConfig.initSplides();
  SplideConfig.initDelayedSplides();
  SplideConfig.initializeProductGallery();
});
// Reinitialize on Shopify section load
document.addEventListener('shopify:section:load', function () {
  SplideConfig.initSplides();
  SplideConfig.initDelayedSplides();
  SplideConfig.initializeProductGallery();
});
document.addEventListener('shopify-facets:container-rendered', function () {
  SplideConfig.initSplides('.splide-collection-banner');
});

// Reinitialize on quick add modal open
document.body.addEventListener('quick-add-modal:opened', function () {
  SplideConfig.initializeProductGallery();
});
window.addEventListener('init-slpiders', function () {
  console.log('init-sliders event fired');
  SplideConfig.initSplides();
});
document.addEventListener('DOMContentLoaded', function () {
  window.addEventListener('init-slpiders', function () {
    SplideConfig.initSplides();
    SplideConfig.initDelayedSplides();
    SplideConfig.initializeProductGallery();
  });
});
/******/ })()
;